/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDriverVehicleAssignments: (params) => {
    return axios.get(API_ENDPOINTS.GET_DRIVER_VEHICLE_ASSIGNMENTS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
      params,
    });
  },
};
